import { lazy } from 'react';

const EditInviteTemplateModal = lazy(() =>
  import('modules/IndustryPartnerCRM/components/EditInviteTemplateModal'),
);

const ManageAffiliationsModal = lazy(() =>
  import('modules/IndustryPartnerCRM/components/ManageAffiliationsModal'),
);

const ManageFieldsModal = lazy(() =>
  import('modules/IndustryPartnerCRM/components/ManageFieldsModal'),
);

const ReviewInvitationsModal = lazy(() =>
  import('modules/IndustryPartnerCRM/components/ReviewInvitationsModal'),
);

const InvitationLinkModal = lazy(() =>
  import('modules/IndustryPartnerCRM/components/InvitationLinkModal'),
);

const EngagementLogEntryModal = lazy(() =>
  import('modules/IndustryPartnerCRM/components/EngagementLogEntryModal'),
);

export default {
  EDIT_INVITE_TEMPLATE_MODAL: EditInviteTemplateModal,
  MANAGE_AFFILIATIONS_MODAL: ManageAffiliationsModal,
  MANAGE_FIELDS_MODAL: ManageFieldsModal,
  REVIEW_INVITATIONS_MODAL: ReviewInvitationsModal,
  INVITATION_LINK_MODAL: InvitationLinkModal,
  ENGAGEMENT_LOG_ENTRY_MODAL: EngagementLogEntryModal,
};
